import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { gsap } from 'gsap/gsap-core';
import { md } from '../common';

export function initTrustedBy() {
  const parent = document.querySelector('.trusted-by');
  if (!parent) return;

  new Swiper('.trusted-by__swiper', {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 25,
    autoplay: { delay: 2000 },
    breakpoints: {
      [md]: {
        spaceBetween: 65,
      },
      2500: { spaceBetween: 90 },
      3800: { spaceBetween: 120 },
    },
  });

  const window = parent.querySelector('.trusted-by__app');
  const app = parent.querySelector('.trusted-by__app img');

  gsap.set(app, { opacity: 0 });

  // Set initial position - top of app at top of window
  gsap.set(app, {
    opacity: 0,
  });

  // Window entrance animation
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: window,
      // markers: true,
      start: 'top bottom-=200px',
    },
  });
  tl.fromTo(
    window,
    { opacity: 0, y: '5%', scaleX: 0.8 },
    { opacity: 1, y: 0, scaleX: 1 },
  );
  tl.fromTo(app, { opacity: 0 }, { opacity: 1 });
}
